"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMetaFile = void 0;
const papaparse_1 = require("papaparse");
async function parseMetaFile(file) {
    const data = file instanceof File ? file : await file.text();
    return new Promise((complete, error) => {
        (0, papaparse_1.parse)(data, {
            header: true,
            dynamicTyping: true,
            complete,
            error,
        });
    });
}
exports.parseMetaFile = parseMetaFile;
